import { agentDisplayName } from "@/lib/agent-display-name";
import { cn } from "@/lib/utils";
import { NvCardLink } from "./nv-card-link";
import { NvInitialTile } from "./nv-initial-tile";
import { NvLockIcon } from "./nv-icons";

// HOME "Certified Agents" 행 (Figma ver.7 "Row / Certified Agent (ver.5)", 10/13 정의서 맞춤):
// 로고 · 에이전트명 · 공급사명 · 한 줄 소개만 — 평점 · 도입 건수 · Certified 알약은 없어요.
// 로고가 없으면 이니셜 타일(40 · r10). △(비회원 · 승인 대기 · 공급자)는 소개를 흐리게, 행 오른쪽에 자물쇠만 두고
// "로그인하면 …" 안내는 영역 맨 위 한 곳(NvLoginPrompt banner)에서 해요(제안 21).
export interface NvCertifiedListRowProps {
  name: string;
  supplier?: string;
  summary: string;
  logoUrl?: string;
  // 이니셜 타일 색을 고르는 키 (에이전트 id)
  toneKey?: string;
  locked?: boolean;
  to?: string;
  linkState?: unknown;
  className?: string;
}

function NvCertifiedListRow({ name, supplier, summary, logoUrl, toneKey, locked = false, to, linkState, className }: NvCertifiedListRowProps) {
  return (
    // 행 높이: 회원 82.1(위아래 16.5 + 글 48 + 아래 선 1) — Certified 7행이 주목받는 10행 카드와 같은 높이가 돼요. 비회원은 안내 띠가 있어 72(11.5)
    <div className={cn("relative flex items-center gap-[14px] border-b border-nv-border", locked ? "py-[11.5px]" : "py-[16.5px]", className)}>
      {logoUrl ? (
        <span className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-nv-control bg-nv-bg-page">
          <img src={logoUrl} alt="" className="h-full w-full object-contain" />
        </span>
      ) : locked ? (
        <span aria-hidden className="h-10 w-10 shrink-0 rounded-nv-control bg-nv-bg-page" />
      ) : (
        <NvInitialTile name={name} toneKey={toneKey} variant="row" />
      )}

      <div className="flex min-w-0 flex-1 flex-col gap-[2px]">
        <NvCardLink to={to} state={linkState} className="truncate text-[14px] font-medium leading-[17px] text-nv-text-primary">
          {agentDisplayName(name)}
        </NvCardLink>
        {supplier && <span className="truncate text-[11px] leading-[13px] text-nv-text-secondary">{supplier}</span>}
        {/* △는 한 줄 소개를 흐리게 (Figma LAYER_BLUR 10 → CSS 5px) */}
        <span className={cn("truncate text-[12px] leading-[14px] text-nv-text-secondary", locked && "select-none blur-[5px]")} aria-hidden={locked || undefined}>
          {summary}
        </span>
      </div>

      {locked && <NvLockIcon size={14} className="shrink-0 text-nv-text-primary" />}
    </div>
  );
}

export { NvCertifiedListRow };
